// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import { SchoolTypeaheadSchoolFragmentDoc } from '../../typeahead/__generated-gql-types__/SchoolTypeahead.generated';
import { CategoryTypeaheadCategoryFragmentDoc } from '../../typeahead/__generated-gql-types__/CategoryTypeahead.generated';
import { CompanyTypeaheadCompanyFragmentDoc } from '../../typeahead/__generated-gql-types__/CompanyTypeahead.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SearchFiltersSubCategoryFragment = {
  __typename?: 'SubCategory';
  id: string;
  name: string;
  slug: string;
};

export type SearchFiltersSchoolFragment = {
  __typename?: 'School';
  id: string;
  name: string;
  logoLink?: string | null;
};

export type SearchFiltersCoachingFocusFragment = {
  __typename?: 'CoachingFocus';
  id: string;
  name: string;
  description?: string | null;
  libraryPath?: string | null;
};

export type SearchFiltersCategoryFragment = {
  __typename?: 'Category';
  id: string;
  name: string;
  goal: Types.GoalName;
  shouldShowSubCategories?: boolean | null;
  subCategoryTitle?: string | null;
  slug: string;
  coachingFocusList?: Array<{
    __typename?: 'CoachingFocus';
    id: string;
    name: string;
    description?: string | null;
    libraryPath?: string | null;
  }> | null;
  subCategoryList?: Array<{
    __typename?: 'SubCategory';
    id: string;
    slug: string;
    v2Urn: string;
    name: string;
  }> | null;
};

export type SearchFiltersSkuFragment = {
  __typename?: 'Sku';
  id: string;
  tier: Types.SkuTier;
  unitPrice: number;
};

export type SearchFiltersGetSchoolsQueryVariables = Types.Exact<{
  ids:
    | Array<Types.Scalars['SchoolUrn']['input']>
    | Types.Scalars['SchoolUrn']['input'];
}>;

export type SearchFiltersGetSchoolsQuery = {
  __typename?: 'Query';
  schoolsByIds: Array<{
    __typename?: 'School';
    id: string;
    name: string;
    logoLink?: string | null;
  }>;
};

export type SearchFiltersGetCompaniesQueryVariables = Types.Exact<{
  ids:
    | Array<Types.Scalars['CompanyUrn']['input']>
    | Types.Scalars['CompanyUrn']['input'];
}>;

export type SearchFiltersGetCompaniesQuery = {
  __typename?: 'Query';
  companiesByIds: Array<{
    __typename?: 'Company';
    id?: string | null;
    name: string;
    domain?: string | null;
    logoLink?: string | null;
  }>;
};

export const SearchFiltersSchoolFragmentDoc = gql`
  fragment SearchFilters_School on School {
    ...SchoolTypeahead_School
  }
  ${SchoolTypeaheadSchoolFragmentDoc}
`;
export const SearchFiltersCoachingFocusFragmentDoc = gql`
  fragment SearchFilters_CoachingFocus on CoachingFocus {
    id
    name
    description
    libraryPath
  }
`;
export const SearchFiltersSubCategoryFragmentDoc = gql`
  fragment SearchFilters_SubCategory on SubCategory {
    id
    name
    slug
  }
`;
export const SearchFiltersCategoryFragmentDoc = gql`
  fragment SearchFilters_Category on Category {
    id
    name
    goal
    shouldShowSubCategories
    coachingFocusList {
      ...SearchFilters_CoachingFocus
    }
    subCategoryList {
      ...SearchFilters_SubCategory
    }
    subCategoryTitle
    ...CategoryTypeahead_Category
  }
  ${SearchFiltersCoachingFocusFragmentDoc}
  ${SearchFiltersSubCategoryFragmentDoc}
  ${CategoryTypeaheadCategoryFragmentDoc}
`;
export const SearchFiltersSkuFragmentDoc = gql`
  fragment SearchFilters_Sku on Sku {
    id
    tier
    unitPrice
  }
`;
export const SearchFiltersGetSchoolsDocument = gql`
  query SearchFilters_GetSchools($ids: [SchoolUrn!]!) {
    schoolsByIds(ids: $ids) {
      ...SearchFilters_School
    }
  }
  ${SearchFiltersSchoolFragmentDoc}
`;

/**
 * __useSearchFiltersGetSchoolsQuery__
 *
 * To run a query within a React component, call `useSearchFiltersGetSchoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchFiltersGetSchoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchFiltersGetSchoolsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSearchFiltersGetSchoolsQuery(
  baseOptions: Apollo.QueryHookOptions<
    SearchFiltersGetSchoolsQuery,
    SearchFiltersGetSchoolsQueryVariables
  > &
    (
      | { variables: SearchFiltersGetSchoolsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SearchFiltersGetSchoolsQuery,
    SearchFiltersGetSchoolsQueryVariables
  >(SearchFiltersGetSchoolsDocument, options);
}
export function useSearchFiltersGetSchoolsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchFiltersGetSchoolsQuery,
    SearchFiltersGetSchoolsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SearchFiltersGetSchoolsQuery,
    SearchFiltersGetSchoolsQueryVariables
  >(SearchFiltersGetSchoolsDocument, options);
}
export function useSearchFiltersGetSchoolsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchFiltersGetSchoolsQuery,
    SearchFiltersGetSchoolsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SearchFiltersGetSchoolsQuery,
    SearchFiltersGetSchoolsQueryVariables
  >(SearchFiltersGetSchoolsDocument, options);
}
export type SearchFiltersGetSchoolsQueryHookResult = ReturnType<
  typeof useSearchFiltersGetSchoolsQuery
>;
export type SearchFiltersGetSchoolsLazyQueryHookResult = ReturnType<
  typeof useSearchFiltersGetSchoolsLazyQuery
>;
export type SearchFiltersGetSchoolsSuspenseQueryHookResult = ReturnType<
  typeof useSearchFiltersGetSchoolsSuspenseQuery
>;
export type SearchFiltersGetSchoolsQueryResult = Apollo.QueryResult<
  SearchFiltersGetSchoolsQuery,
  SearchFiltersGetSchoolsQueryVariables
>;
export const SearchFiltersGetCompaniesDocument = gql`
  query SearchFilters_GetCompanies($ids: [CompanyUrn!]!) {
    companiesByIds(ids: $ids) {
      ...CompanyTypeahead_Company
    }
  }
  ${CompanyTypeaheadCompanyFragmentDoc}
`;

/**
 * __useSearchFiltersGetCompaniesQuery__
 *
 * To run a query within a React component, call `useSearchFiltersGetCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchFiltersGetCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchFiltersGetCompaniesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSearchFiltersGetCompaniesQuery(
  baseOptions: Apollo.QueryHookOptions<
    SearchFiltersGetCompaniesQuery,
    SearchFiltersGetCompaniesQueryVariables
  > &
    (
      | { variables: SearchFiltersGetCompaniesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SearchFiltersGetCompaniesQuery,
    SearchFiltersGetCompaniesQueryVariables
  >(SearchFiltersGetCompaniesDocument, options);
}
export function useSearchFiltersGetCompaniesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchFiltersGetCompaniesQuery,
    SearchFiltersGetCompaniesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SearchFiltersGetCompaniesQuery,
    SearchFiltersGetCompaniesQueryVariables
  >(SearchFiltersGetCompaniesDocument, options);
}
export function useSearchFiltersGetCompaniesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchFiltersGetCompaniesQuery,
    SearchFiltersGetCompaniesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SearchFiltersGetCompaniesQuery,
    SearchFiltersGetCompaniesQueryVariables
  >(SearchFiltersGetCompaniesDocument, options);
}
export type SearchFiltersGetCompaniesQueryHookResult = ReturnType<
  typeof useSearchFiltersGetCompaniesQuery
>;
export type SearchFiltersGetCompaniesLazyQueryHookResult = ReturnType<
  typeof useSearchFiltersGetCompaniesLazyQuery
>;
export type SearchFiltersGetCompaniesSuspenseQueryHookResult = ReturnType<
  typeof useSearchFiltersGetCompaniesSuspenseQuery
>;
export type SearchFiltersGetCompaniesQueryResult = Apollo.QueryResult<
  SearchFiltersGetCompaniesQuery,
  SearchFiltersGetCompaniesQueryVariables
>;
